import { module } from 'modujs';
import Vue from 'vue';

const EVENTS = {
    ROUTE_CHANGE: 'theme.routechanged'
}



export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.initEvents()

        var BaseComponent = Vue.extend({
            methods: {
                foo: function() { console.log('foo') }
            }
        });

          let myComponentInstance = new BaseComponent()
    }

    initEvents() {
        /**
         * Prevent unwanted popState transition
         *
         */

        let validateEmploye = () => {
            fetch('/wp-json/employe/list')
            .then(response => response.json())
            .then(result => {
                if (result && result.rebate) {
                    Snipcart.api.cart.applyDiscount(result.rebate);
                    Snipcart.api.cart.fetchShippingRates();
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        }

        let validateCompany = () => {
            fetch('/wp-json/employe/list')
            .then(response => response.json())
            .then(result => {
                if (result && result.rebate) {
                    console.log(Snipcart.store.getState());
                    Snipcart.api.cart.applyDiscount(result.rebate);
                    Snipcart.api.cart.fetchShippingRates();
                    let freebees = document.getElementById('reward');
                    freebees.style.display = 'none';
                    Snipcart.store.getState().customer.billingAddress.company = '';

                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        }

        let validateCartItems = () => {
            let html = document.querySelector('html');
            html.classList.remove('giftcard-error');
            html.classList.remove('has-precommande');
            Snipcart.store.getState().cart.items.items.forEach(el => {
                try{
                    if(el.metadata.presale == true) {
                        html.classList.add('has-precommande');
                    }
                    if(el.metadata.is_giftcard == true) {
                        Snipcart.api.cart.items.remove(el.id);
                        html.classList.add('giftcard-error');
                    }
                } catch(e){}
            })
            validateShipping();
            //Snipcart.api.cart.applyDiscount('odoo_rebate');
        }

        let validateShipping = () => {
            let html = document.querySelector('html');
            html.classList.remove('stock-error');
            let in_stock = true;
            let in_stock_boutique = true;
            Snipcart.store.getState().cart.items.items.forEach(el => {
                try{
                    if(el.metadata.in_stock == false) {
                        in_stock = false;
                    }
                    if(el.metadata.in_stock_boutique == false) {
                        in_stock_boutique = false;
                    }
                } catch(e){}
            })
            if(in_stock == false && in_stock_boutique == false) {
                html.classList.add('stock-error');
            } else{
                html.classList.remove('stock-error');
            }
        }

        let updateRandollards = () => {
            let snipcartState = Snipcart.store.getState();
            let card = snipcartState.cart.billingAddress.company; //Carte par default
            let fd = new FormData();
            fd.append('total', snipcartState.cart.total);
            fd.append('card',card);
            fd.append('items',JSON.stringify(snipcartState.cart.items.items));
            fetch('/wp-json/freebees/v1/reward',{method: "POST",body: fd})
            .then(response => response.json())
            .then(data => { 
                if(!data.success){
                    document.getElementById('reward').style.display = 'none';
                    document.getElementById('icon-randollars').style.display = 'block';
                    document.getElementById('freebees_notice').style.display = 'flex';
                    document.getElementById('freebees_notice_text').innerHTML = data.response.data.Result.Errors.Error.ShortMsg;
                } else {
                    document.getElementById('reward').style.display = 'flex';
                    document.getElementById('reward-randollars').innerHTML = data.data/100;
                    if(!card) document.getElementById('freebees_notice').style.display = 'flex'; else document.getElementById('freebees_notice').style.display = 'none';
                }
            });
        }

        let getRandollars = () => {
            let snipcartState = Snipcart.store.getState();
            let card = snipcartState.customer.billingAddress.company; //Carte par default
            if(!card) {
                document.getElementById('freebees_notice').style.display = 'block';
                return false;
            }
            
            Snipcart.api.cart.update({
                email: snipcartState.customer.email,
                billingAddress: snipcartState.customer.billingAddress
            });

            let fd = new FormData();
            fd.append('type', 'points');
            fd.append('number',card);
            fetch('/wp-json/freebees/v1/validate',{method: "POST",body: fd})
            .then(response => response.json())
            .then(data => { 
                if(!data.success){
                    document.getElementById('freebees_notice').innerHTML += '<span>'+data.response.data.Result.Errors.Error.LongMsg+'</span>';
                    document.getElementById('freebees_notice').style.display = 'flex';
                } else {
                    document.getElementById('solde-randollars-solde').innerHTML = data.balance;
                    document.getElementById('solde-randollars').style.display = 'flex';
                }
            });
        }

        Snipcart.events.on('cart.confirmed', (cartConfirmResponse) => {
            try { gtag('event', 'conversion', { 'send_to': 'AW-358219354/IgXaCKXcqeMDENr856oB', 'value': cartConfirmResponse.total, 'currency': 'CAD', 'transaction_id': cartConfirmResponse.invoiceNumber });  } catch(e) {}
        });

        let validateCart = () => {
            Snipcart.store.getState().cart.items.items.forEach(el => {
                try{
                    if(el.metadata.is_giftcard == true) {
                        Snipcart.api.cart.removeDiscount();
                    }
                } catch(e){}
            })
        }

        Snipcart.events.on('discount.applied', validateCart);
        Snipcart.events.on('customer.signedin', validateEmploye);
        Snipcart.events.on('summary.checkout_clicked',validateCartItems);
        Snipcart.events.on('shipping.selected',validateCartItems);
        Snipcart.events.on('item.added',validateCartItems);
        Snipcart.events.on('item.removed',validateCartItems);
        Snipcart.events.on('item.updated',validateCartItems);
        Snipcart.events.on('snipcart.initialized',validateCartItems);
        Snipcart.events.on('shipping.selected',updateRandollards);
        Snipcart.events.on(EVENTS.ROUTE_CHANGE, (routesChange) => {
            console.log(routesChange)
            if(routesChange.to == '/checkout') {
                updateRandollards();
                validateCompany();
            }
            // Cart open
            if (routesChange.from === "/" && routesChange.to !== "/") {
                window.preventPopstate = true
            }

            // Cart close
            if (routesChange.from !== "/" && routesChange.to === "/") {
                window.preventPopstate = false
            }

            if(routesChange.to == "/dashboard") {
                getRandollars();
            }

            // Accounts :: @TODO make this work :S
            // ==========================================================================
            if (routesChange.from === "/signin" && routesChange.to !== "/") {
                console.log('preventPopstate true oui')
                window.preventPopstate = true
            }

            if (routesChange.from === "/register" && routesChange.to !== "/") {
                console.log('preventPopstate true oui')
                window.preventPopstate = true
            }
        })
    }

    destroy() {
        super.destroy()
    }
}
